null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala-js/scala-js/v0.6.25/library/src/main/scala-old-collections/scala/scalajs/js/WrappedDictionary.scala